/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * star 
 * ======================================================================== 
 * 1/15/2016: creation
 * 5/2/2016: new parent handler
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="star"]';
    var PARENT = '[data-parent="true"]';


    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 75,
        value: '',
        noedit: false,
        color: '',      //  pass class in

        reset: function (value) {
            var e = $(this.element);
            e.data().value = value;

            if (value) {
                e.children('i').removeClass(star.in).removeClass(star.out).addClass(star.in);
            } else {
                e.children('i').removeClass(star.in).removeClass(star.out).addClass(star.out);
            }
        }
    };


    //  star
    var star = {
        in: 'fa-star',
        out: 'fa-star-o'
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set event
        $(document).off('click', ELEM);
        $(document).on('click.' + NAMESPACE, ELEM, clickStar);
    }


    //  get star
    function getStar(wireEvent, container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }


        //  wire events
        if (wireEvent) setEvents();


        //  bail
        if (list.length === 0) return;


        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());


            //  set elem data
            me.setControlItemOptions(elem, options);


            //  reset string -> bool
            if (typeof options.value === 'string') options.value = options.value.getBool();


            //  set data
            elem.data(options);


            //  reset
            elem.html('').append("<i class='fa fa-fw " + options.color + "'></i>");
            options.reset(options.value);


            //  set cursor
            if (!options.noedit) elem.css({ cursor: 'pointer' });
        });
    }






    //  click star
    function clickStar() {
        var e = $(this);
        e.data().element = e;

        var data = e.data();

        if (data.noedit) return;

        var value = data.value;

        if (value) {
            data.value = false;
            e.children('i').removeClass(star.in).addClass(star.out);
        } else {
            data.value = true;
            e.children('i').removeClass(star.out).addClass(star.in);
        }

        e.data(data);

        //  callback
        data = e.data();
        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
    }






    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    
    //  set star
    child.setStar = function (wireEvent, container) {
        getStar(wireEvent, container);
    }


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));